import { render } from "./index.vue?vue&type=template&id=e9001dee"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=e9001dee&lang=scss"
script.render = render

export default script